import api from "../api/onBoarding.resource";
import { embeddedSpacesPattern } from "../constants/constants";
import actionTypes from "./onBoardingActionTypes";
import { getUpdatedValueByFieldType } from "../util/helpers";

export const onBoardingActions = {
  getPersonalDetails: candidateID => async dispatch => {
    try {
      const res = await api.getPersonalDetails(candidateID);
      dispatch({ type: actionTypes.GET_PERSONAL_DETAILS, res });
    } catch (e) {
      console.log(e);
    }
  },

  updatePersonalDetails:
    (fieldName, fieldValue, objName = "", id = "", fieldType = "") =>
    dispatch => {
      try {
        //Avoid this condition for Text Area Fields
        if (embeddedSpacesPattern.test(fieldValue))
          dispatch({
            type: actionTypes.UPDATE_PERSONAL_DETAILS,
            fieldName,
            fieldValue: getUpdatedValueByFieldType(fieldType, fieldValue),
            objName,
            id
          });
      } catch (e) {
        console.log(e);
      }
    },
  updateOtherBankDetails: (fieldName, fieldValue) => dispatch => {
    try {
      dispatch({
        type: actionTypes.UPDATE_OTHER_BANK_DETAILS,
        fieldName,
        fieldValue
      });
    } catch (e) {
      console.log(e);
    }
  },
  getRelationShipList: loggedInUserId => async dispatch => {
    try {
      const res = await api.getRelationshipList(loggedInUserId);
      dispatch({ type: actionTypes.GET_RELATIONSHIP_LIST, res });
    } catch (e) {
      console.log(`e`, e);
    }
  },
  addRelationDetails: newRelationDetails => {
    return {
      type: actionTypes.ADD_RELATION_DETAILS,
      newRelationDetails
    };
  },
  deleteRelationDetails: relationId => {
    return {
      type: actionTypes.DELETE_RELATION_DETAILS,
      relationId
    };
  },
  addGratuityDetails: newGratuityDetails => {
    return {
      type: actionTypes.ADD_GRATUITY_NOMINEE_DETAILS,
      newGratuityDetails
    };
  },
  deleteGratuityDetails: familyMemberId => {
    return {
      type: actionTypes.DELETE_GRATUITY_NOMINEE_DETAILS,
      familyMemberId
    };
  },
  updateNomineeDetails: (fieldName, fieldValue, objName, id) => dispatch => {
    try {
      dispatch({
        type: actionTypes.UPDATE_NOMINEE_DETAILS,
        fieldName,
        fieldValue,
        objName,
        id
      });
    } catch (e) {
      console.log(e);
    }
  },
  addEPFFrom2Details: newPFDetails => {
    return {
      type: actionTypes.ADD_EPFFORM2_NOMINEE_DETAILS,
      newPFDetails
    };
  },
  deleteEPFFrom2Details: familyMemberId => {
    return {
      type: actionTypes.DELETE_EPFFORM2_NOMINEE_DETAILS,
      familyMemberId
    };
  }
};
